import { RugbyLeagueIncidentId } from '@collector/sportsapi-client-legacy'

import { IncidentsTeamPossessionConfig } from '../../../configuration'

export const incidentsTeamPossessionConfig: IncidentsTeamPossessionConfig<RugbyLeagueIncidentId> =
  {
    swapPossessionIncidents: new Set([RugbyLeagueIncidentId.TackleMade]),
  }
